import { createFileRoute } from "@tanstack/react-router";
import { HarvestAnalysis } from "@/features/harvest-analysis/harvest-analysis";
import { JournalPage } from "@/features/harvest-journal/components/journal-page";

export const Route = createFileRoute("/harvests/$session_id/analysis")({
  component: RouteComponent,
});

function RouteComponent() {
  const { session_id } = Route.useParams();

  return (
    <JournalPage>
      <HarvestAnalysis sessionId={session_id} />
    </JournalPage>
  );
}
